export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "داشبورد",
        to: "/manager/dashboard",
        icon: "cil-home",
      },
      {
        _name: "CSidebarNavItem",
        name: "اخبار",
        to: "/manager/news",
        icon: "cil-newspaper",
      },
      {
        _name: "CSidebarNavItem",
        name: "دانش‌آموزان",
        to: "/manager/student",
        icon: "cil-user",
      },
      {
        _name: "CSidebarNavItem",
        name: "کادر آموزشی",
        to: "/manager/staff",
        icon: "cil-people",
      },
      {
        _name: "CSidebarNavItem",
        name: "تکالیف و محتوای آموزشی",
        to: "/manager/course",
        icon: "cil-school",
      },
      {
        _name: "CSidebarNavItem",
        name: "بانک سوالات",
        to: "/manager/bank",
        icon: "cil-bank",
      },
      {
        _name: "CSidebarNavItem",
        name: "آزمون آنلاین",
        to: "/manager/exam",
        icon: "cil-task",
      },
      {
        _name: "CSidebarNavItem",
        name: "ارزشیابی و نمرات",
        to: "/manager/offexam",
        icon: "cil-task",
      },
      {
        _name: "CSidebarNavItem",
        name: "گزارشات",
        to: "/manager/report",
        icon: "cil-chart",
      },
      {
        _name: "CSidebarNavItem",
        name: "نظر سنجی",
        to: "/manager/poll",
        icon: "cil-check-circle",
      },
      {
        _name: "CSidebarNavItem",
        name: "تیکت",
        to: "/manager/ticket",
        icon: "cil-chat-bubble",
      },
    ],
  },
];